import React from 'react';

interface ReporterSpecialAwardModalProps {
  show: boolean;
  onClose: () => void;
  year?: string;
}

const ReporterSpecialAwardModal: React.FC<ReporterSpecialAwardModalProps> = ({ show, onClose, year = '114年度' }) => {
  if (!show) return null;
  return (
    <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex={-1} role="dialog" aria-modal="true">
      <div className="modal-dialog max-width-1200 modal-dialog-centered" role="document">
        <div className="modal-content mx-3">
          <div className="modal-header">
            <h5 className="modal-title">{year}報導者特別獎</h5>
            <button type="button" className="btn-close" onClick={onClose} aria-label="Close">
              <span aria-hidden="true" className="text-dark" style={{ fontSize: 36, lineHeight: '12px' }}>&times;</span>
            </button>
          </div>
          <div className="modal-body pb-3" style={{ height: '70vh', maxHeight: 530, overflowY: 'auto' }}>
            <div className="text-dblue p-3 p-md-4">
              <p>　　「財團法人報導者文化基金會」是台灣第一個公益基金會成立的網路媒體， 致力於公共領域深度報導， 2022年起推出「少年報導者」兒少新聞平台，展開與10到15歲的孩子對話。</p>
              <p>　　讓孩子透過資訊探查， 了解社會嚴肅事件的脈絡， 是民主社會重要的事， 透過林玫伶顧問獲悉柯華葳線上探究競賽，《報導者》希望藉由「報導者特別獎」的形式， 彰顯此一活動除具教育意義， 更有提升公民社會的價值。</p>
            </div>
            <h5 className="text-center">【{year}獲獎名單】獎項及獎品提供：財團法人報導者文化基金會</h5>
            {year === '114年度' && (
              <>
            {/* 國小A組 */}
            <div className="card p-2 mx-0 mx-md-3 my-4">
              <div className="mt-3 me-auto text-second fw-bolder">【國小A組】新工具探索獎</div>
              <div className="table-responsive text-start">
                <table className="text-sm table table-striped">
                  <tbody>
                    <tr>
                      <td>獲獎隊伍</td>
                      <td className="text-wrap">新竹縣中山國小 HA010-07 未來小隊</td>
                    </tr>
                    <tr>
                      <td>探究題目</td>
                      <td className="text-wrap">小學生適合用AI嗎？</td>
                    </tr>
                    <tr>
                      <td>獲獎原因</td>
                      <td className="text-wrap">
                        人工智慧已深入生活，小學生的提問也不再只是「能不能用AI」，而是更進一步思考：「該怎麼用？哪一種最適合我們？」<br />
                        他們透過探究的歷程，主動蒐集市面常見的AI軟體，分析功能差異，進行個人試用與評比，並針對自身年齡層提出具體建議。在教師與家長的引導下，小學生適度運用AI，應用於圖像生成、語音互動或簡易搜尋等。<br />
                        面對日新月異的科技，展現出數位時代中思辨與行動並重的學習精神。
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            {/* 國小B組 */}
            <div className="card p-2 mx-0 mx-md-3 my-4">
              <div className="mt-3 me-auto text-second fw-bolder">【國小B組】責任思辨獎</div>
              <div className="table-responsive text-start">
                <table className="text-sm table table-striped">
                  <tbody>
                    <tr>
                      <td>獲獎隊伍</td>
                      <td className="text-wrap">新北市實踐國小 HB007-02 不知道晚一點再說隊</td>
                    </tr>
                    <tr>
                      <td>探究題目</td>
                      <td className="text-wrap">校園打掃大家一起來</td>
                    </tr>
                    <tr>
                      <td>獲獎原因</td>
                      <td className="text-wrap">
                        提出一個好問題，是獨立思考的起點。這組小學生從日常的校園打掃出發，進一步思考其責任應由誰來承擔。他們不僅從「打掃有助於培養學生品格」這個觀點切入，更在探究過程中嘗試超越「願不願意」的個人感受，轉向透過資料蒐集與比較國際做法，逐步進行辯證與討論。這樣的過程，不僅深化了對責任與公共空間的理解，也展現了小學生參與公共事務、發展公民素養的初步萌芽。
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            {/* 國中C組 */}
            <div className="card p-2 mx-0 mx-md-3 my-4">
              <div className="mt-3 me-auto text-second fw-bolder">【國中C組】毛孩勇士獎</div>
              <div className="table-responsive text-start">
                <table className="text-sm table table-striped">
                  <tbody>
                    <tr>
                      <td>獲獎隊伍</td>
                      <td className="text-wrap">臺中市四育國中 HC015-01 森江貓狗隊</td>
                    </tr>
                    <tr>
                      <td>探究題目</td>
                      <td className="text-wrap">十二夜之後：流浪貓狗的終養？</td>
                    </tr>
                    <tr>
                      <td>獲獎原因</td>
                      <td className="text-wrap">
                        同學展現很強的共感能力，關懷生活周遭事物，看見非人的流浪貓狗困境，進而延伸至動物生命權議題的討論。探究架構完整度高，爬梳台灣的零安樂死政策脈絡，也援引國際案例參考比較，提出多方面的解方。此外，藉由線上探究了解議題後，還能身體力行在校園舉辦快閃宣導活動，為無法說話的毛孩發聲，令評審動容。
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            {/* 國中D組 */}
            <div className="card p-2 mx-0 mx-md-3 my-4">
              <div className="mt-3 me-auto text-second fw-bolder">【國中D組】新聞模範生獎</div>
              <div className="table-responsive text-start">
                <table className="text-sm table table-striped">
                  <tbody>
                    <tr>
                      <td>獲獎隊伍</td>
                      <td className="text-wrap">桃園市平鎮國中 HD024-02 明星三缺一隊</td>
                    </tr>
                    <tr>
                      <td>探究題目</td>
                      <td className="text-wrap">誰在說謊？ 一起來抓假新聞！</td>
                    </tr>
                    <tr>
                      <td>獲獎原因</td>
                      <td className="text-wrap">
                        這隊的問題核心圍繞媒體識讀，且報告時「新聞性」十足，起頭就以網友假冒三峽車禍肇事老翁親人的事件帶出假新聞的實際樣貌，安排用心。在發現社會問題後，小隊更積極尋找改善的方法，不僅發放600份問卷掌握身旁同學對假新聞的判別能力，更運用AI工具製作假新聞篩選器，展現優異的數位能力與媒體素養。
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
              </>
            )}
            {year !== '114年度' && (
              <div className="text-center py-5">
                <p>{year}的報導者特別獎資料準備中...</p>
              </div>
            )}
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>關閉</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReporterSpecialAwardModal; 